import { getState, setState } from '../analytics-state';
import { SORT, NO_EVENT } from '../constants';

export const sortRefinements = () => {
  let sortInformation = null;
  const getSortAnalyticsEvent = () => {
    const { name, currentPage, page, sortByPosition } = sortInformation;
    
    return {
      category: {
        primaryCategory: page
      },
      eventInfo: {
        eventName: 'sort by'
      },
      displayAttributes: {
        pageNumber: currentPage,
        productsAvailability: 'all products',
        sortBy: name,
        viewType: 'grid',
        sortByPosition: sortByPosition || '',
      }
    };
  };

  window.LIFE_CYCLE_EVENT_BUS.on('sort-refinements.publish', () => {
    if (sortInformation) {
      digitalData.event = digitalData.event || [];
      digitalData.event.push(getSortAnalyticsEvent());
      sortInformation = null;
    }

    // Clear the transition even when there was nothing left to report, so a SORT
    // can never outlive the interaction that set it and suppress a later
    // interaction's pageload.
    if (getState()?.pageTransitionEvent === SORT) {
      setState({ pageTransitionEvent: NO_EVENT });
    }
  });

  window.LIFE_CYCLE_EVENT_BUS.on('sort-refinements.click', function ({ output }) {
    sortInformation = output;
    setState({
      ...getState(),
      pageTransitionEvent: SORT
    });
  });
};